"use client"

import { useEffect, useState } from "react"
import { Bar, BarChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts"
import axios from "axios"
import { Calendar } from "lucide-react" // Import Calendar icon

export default function UserChart() {
  const [userData, setUserData] = useState([])
  const [filters, setFilters] = useState({ fromDate: "", toDate: "" })
  const [showFilter, setShowFilter] = useState(false)

  useEffect(() => {
    fetchData()
  }, [filters])

  const fetchData = async () => {
    try {
      const query = new URLSearchParams(filters).toString()
      const url = query ? `http://localhost:5000/user-stats?${query}` : `http://localhost:5000/user-stats`
      const response = await axios.get(url)
      const data = response.data.map((item) => ({
        ...item,
        professional: item.professional || 0,
        client: item.business || 0, // Fix key mismatch for 'client'
        admin: item.admin || 0,
      })) // Ensure all keys exist with default values
      setUserData(data)
    } catch (error) {
      console.error("Error fetching user data:", error)
    }
  }

  return (
    <div className="relative">
      <ResponsiveContainer width="100%" height={300}>
        {userData.length > 0 ? ( // Check if data exists before rendering the chart
          <BarChart data={userData} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" label={{ value: "Month", position: "insideBottom", offset: -50 }} />
            <YAxis label={{ value: "Count", angle: -90, position: "insideLeft", offset: 10 }} />
            <Tooltip />
            <Legend />
            <Bar dataKey="professional" stackId="a" fill="#8884d8" name="Professional" />
            <Bar dataKey="client" stackId="a" fill="#82ca9d" name="Client" />
            <Bar dataKey="admin" stackId="a" fill="#ffc658" name="Admin" />
          </BarChart>
        ) : (
          <p className="text-center text-gray-500">No data available</p>
        )}
      </ResponsiveContainer>
      <Calendar
        className="absolute top-2 right-2 w-5 h-5 text-gray-500 cursor-pointer"
        onClick={() => setShowFilter(!showFilter)}
      />
      {showFilter && (
        <div className="absolute top-10 right-0 z-10 p-4 bg-white border rounded shadow">
          <h3 className="mb-2 text-sm font-semibold">User Chart Filter</h3>
          <label className="block mb-2 text-xs">
            From Date:
            <input
              type="date"
              className="block w-full p-1 border rounded"
              value={filters.fromDate}
              onChange={(e) => setFilters((prev) => ({ ...prev, fromDate: e.target.value }))}
            />
          </label>
          <label className="block mb-2 text-xs">
            To Date:
            <input
              type="date"
              className="block w-full p-1 border rounded"
              value={filters.toDate}
              onChange={(e) => setFilters((prev) => ({ ...prev, toDate: e.target.value }))}
            />
          </label>
          <button
            className="px-2 py-1 text-xs text-white bg-blue-500 rounded"
            onClick={() => setShowFilter(false)}
          >
            Apply
          </button>
        </div>
      )}
    </div>
  )
}
